import styled from 'styled-components';

export const ManualRoutingModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SimpleRoutingVtItensContainer =  styled.div`
  border-top: 2px solid ${({ theme }) => theme.colors.gray[75]};
  padding-top: 16px;
  margin-top: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
